'use client';

export function getTrpcUrl() {
  if (!process.env.NEXT_PUBLIC_API_URL) {
    throw new Error('NEXT_PUBLIC_API_URL is not defined');
  }

  return `${getApiUrl()}/trpc`;
}

export function getApiUrl() {
  if (!process.env.NEXT_PUBLIC_API_URL) {
    throw new Error('NEXT_PUBLIC_API_URL is not defined');
  }

  if (
    process.env.NODE_ENV === 'development' &&
    process.env.NEXT_PUBLIC_DEV === 'true'
  ) {
    return '/api';
  }

  return process.env.NEXT_PUBLIC_API_URL;
}
